import React from 'react';
import './../index.css';
import useFirestore from './../hooks/useFirestore';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
export default function AboutPage() {

  const { documents } = useFirestore('display-picture');
  const hobbies = [
    { key: 'full stack developer', icon: 'LaptopIcon' },
    { key: 'photographer', icon: 'PhotoCameraIcon' },
    { key: 'petrol head', icon: 'SportsMotorsportsIcon' },
    { key: 'traveller', icon: 'LocationOnIcon' },
    { key: 'sports fan', icon: 'LocationOnIcon' }
  ];
  const personal = [
    { key: 'GitHub', link: 'https://github.com/shenoyninad/', icon: <GitHubIcon sx={{ color: 'black' }} />, color: '#666' },
    { key: 'LinkedIn', link: 'https://www.linkedin.com/in/ninad-shenoy-0a931610b/', icon: <LinkedInIcon sx={{ color: 'black' }} />, color: '#0072B1' },
    { key: 'Instagram', link: 'https://www.instagram.com/ninadshenoy/', icon: <InstagramIcon sx={{ color: 'pink' }} />, color: '#833AB4' },
    { key: 'Facebook', link: 'https://www.facebook.com/brainy.ninad/', icon: <FacebookIcon sx={{ color: '#4267B2' }} />, color: '#4267B2' }
  ];

  return (
    <div>
      <div className='about-div'>
        {documents && documents.map((doc) => (
          <Avatar
            alt="Ninad Shenoy"
            src={doc.url}
            sx={{ width: 86, height: 86 }}
          />
        ))}
      </div>
      <br />
      <pre className='about-para'>foxtrot</pre>
      <Button sx={{
        color: 'black',
        backgroundColor: '#6ecabe',
        textTransform: 'none',
        marginTop: '1%',
        border: '2px solid #6ecabe',
        '&:hover': {
          backgroundColor: '#0E0E10',
          color: '#6ecabe',
        }
      }} className='resume-btn' variant="contained" component="span">my resume</Button>
      <Stack className='chip-div' direction="row" spacing={1}>
        {
          personal.map((item) => (
            <Chip
              label={item.key}
              component="a"
              sx={{
                backgroundColor: `white`,
                color: `${item.color}`,
                borderColor: `${item.color}`,
              }}
              href={item.link}
              icon={item.icon}
              variant="outlined"
              clickable
            />
          ))
        }
      </Stack>
      <Stack className='chip-div' direction="row" spacing={1}>
        {
          hobbies.map((hobby) => (
            <Chip color="primary" label={hobby.key} variant="outlined" />
          ))
        }
      </Stack>

    </div>
  )
}